export enum FilterActionTypes {
    SET_FILTER = 'SET_FILTER',
    SORT_PRODUCTS = 'SORT_PRODUCTS',
    PROCESS_FILTER = 'PROCESS_FILTER',
    CHANGE_PARAMETER = 'CHANGE_PARAMETER',
    CHANGE_SLIDE_VALUE = 'CHANGE_SLIDE_VALUE',
    CLEAR_FILTRATION = 'CLEAR_FILTRATION',
    REFETCH_FILTER = 'REFETCH_FILTER'
}